import Image from "next/image";
import Share from "@public/paper-plane.svg";
import { BookmarkIcon } from "@heroicons/react/24/outline";
import { VideoPageQuery } from "@graphql/generated/graphql";
import { Trans } from "@lingui/macro";
import { DialogName, triggerDialog } from "@components/core/dialog";
import { useRouter } from "next/router";

interface INewsActionButtonsProps {
  video: VideoPageQuery["video"];
}

const VideoActionButtons: React.FunctionComponent<INewsActionButtonsProps> = ({
  video,
}) => {
  const router = useRouter();

  const openShareDialog = (event, video) => {
    event.preventDefault();
    triggerDialog(DialogName.share, {
      id: video.id,
      imageUrl: video.imageUrl,
      title: video.title,
      publisherName: video.newsPublisher.name,
      url: `${window.location.origin}/${router.locale}${router.asPath}`,
    });
  };

  const openBookmarkDialog = (event, video) => {
    event.preventDefault();
    triggerDialog(DialogName.bookmark, { id: video.id });
  };

  return (
    <div className="flex flex-row space-x-6">
      <a
        className="cursor-pointer"
        onClick={(event) => openBookmarkDialog(event, video)}
      >
        <div className="flex flex-row justify-between space-x-6 font-sen text-xs font-light text-text-medium ">
          <div className="flex flex-row items-center space-x-2">
            <BookmarkIcon className="h-6 w-6 text-primary3" />
            <p className="hidden md:block">
              <Trans>Bookmark</Trans>
            </p>
          </div>
        </div>
      </a>
      <a
        className="cursor-pointer"
        onClick={(event) => openShareDialog(event, video)}
      >
        <div className="flex flex-row justify-between space-x-6 font-sen text-xs font-light text-text-medium ">
          <div className="mt-[1px] flex flex-row items-center space-x-2">
            <Image src={Share} width={22} height={22} alt="share" />
            <p className="hidden md:block">
              <Trans>Share video</Trans>
            </p>
          </div>
        </div>
      </a>
    </div>
  );
};

export default VideoActionButtons;
